import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=34d28883"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/Projects/PECOS/pecos_ivm_apiserver-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d28883')) {
      api.createRecord('34d28883', component.options)
    } else {
      api.reload('34d28883', component.options)
    }
    module.hot.accept("./payment.vue?vue&type=template&id=34d28883", function () {
      api.rerender('34d28883', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/payment.vue"
export default component.exports